import styled from "styled-components";
import Box from "@mui/material/Box";

export const ModalBox = styled(Box)`
    @media (max-width: 767px) {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
    }
    position: absolute;
    top: 50%;
    left: 50%;
    width: 500px;
    transform: translate(-50%, -50%);
    background-color: var(--white);
    border-radius: 5px;
    padding: 40px;
`;

export const CloseBtn = styled.button`
    position: absolute;
    right: 0;
    top: 0;
    transform: translate(-50%, 50%);
`;

export const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
`;

export const UploadBtn = styled.label`
    &:hover {
        border: ${(props) => (props.disabled ? "none" : `1px solid var(--white)`)};
        cursor: pointer;
    }

    width: 100% !important;
    height: 50px;
    background-color: ${(props) =>
            props.disabled ? `var(--icon-gray)` : `var(--red)`};

    color: ${(props) => (props.disabled ? `var(--dark-gray)` : `var(--white)`)};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    margin-bottom: 10px;
    margin-top: 25px;
    padding: 5px 10px;
`;

export const SendBtn = styled.button`
    &:disabled {
        &:hover {
            border: none;
        }

        background-color: var(--dark-gray);
        cursor: default;
    }

    &:hover {
        border: 1px solid var(--white);
        cursor: pointer;
    }

    width: 100%;
    height: 50px;
    background-color: var(--black);

    color: var(--white);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    margin-bottom: 10px;
    margin-top: 25px;
    padding: 5px 10px;

    font-size: 16px;
`;

export const inputStyles = {
    // "& .MuiBox-root": {
    //   width: "892px",
    //   height: "645px",
    // },
    "& .MuiRadio-root": {
        "&.Mui-checked": {
            color: "black",
        },
    },
    "& .MuiFormLabel-root": {
        "&.Mui-focused ": {
            color: "var(--dark-gray)", // or black
        },
    },
    "& .MuiOutlinedInput-root": {
        "&.Mui-focused fieldset": {
            color: "black",
            borderColor: "var(--dark-gray)",
        },
    },
};

export const Dropzone = styled.label`
    height: max-content;
    border: 1px dashed ${(props) => (props.error ? `var(--red)` : (
            props.disabled ? `var(--disabled-c)` : `var(--dark-gray)`
    ))};
    border-radius: 5px;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    margin-top: 25px;
    padding: 14px;
    gap: 10px;
    cursor: ${(props) => (props.disabled ? `default` : `pointer`)};
`;

export const ReplaceFile = styled.span`
    color: ${(props) => (props.error ? `var(--red)` : (
            props.disabled ? `var(--disabled-c)` : `var(--red)`
    ))};
    width: max-content;
    height: max-content;
    background-color: transparent;
    font-size: 14px;

`;

export const H4 = styled.h4`
    font-size: 12px;
    color: ${(props) => (props.error ? `var(--red)` : `var(--dark-gray)`)};
`;

export const DocName = styled.p`
    width: 100%;
    word-wrap: break-word;
    overflow-wrap: break-word;
    text-align: center;
    font-size: 14px;
    color: ${(props) => (props.error ? `var(--red)` : (
            props.disabled ? `var(--disabled-c)` : `var(--black)`
    ))};
`;
